export enum EnumContractStatus
{
    hold = 2,
    free = 3,
    premium = 4,
    canceled = 5,
    lead = 6
}